import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import './PageBanner.css';

const PageBanner = ({ title, subtitle, backgroundImage }) => {
    const containerRef = useRef(null);
    const { scrollY } = useScroll();

    const backgroundY = useTransform(scrollY, [0, 500], [0, 150]);
    const textOpacity = useTransform(scrollY, [0, 300], [1, 0]);

    return (
        <section ref={containerRef} className="page-banner">
            <motion.div
                className="page-banner-background"
                style={{
                    y: backgroundY,
                    backgroundImage: `url(${backgroundImage || '/images/default-banner.jpg'})`
                }}
            />

            <div className="page-banner-overlay" />

            <motion.div
                className="page-banner-content"
                style={{ opacity: textOpacity }}
            >
                <motion.h1
                    className="page-banner-title"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    {title}
                </motion.h1>
                {subtitle && (
                    <motion.p
                        className="page-banner-subtitle"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                    >
                        {subtitle}
                    </motion.p>
                )}
            </motion.div>
        </section>
    );
};

export default PageBanner;
